import React from 'react'
import { Container, Row } from 'reactstrap'
import { ResultsGrid } from './ResultGrid'
import { ResultsActionSelector } from './ResultsActionSelector'
import { TypeSelectAll } from './TypeSelectAll'
import { useAppSelector } from '../../../hooks/useAppSelector'
import { LoadIndicator } from 'devextreme-react'
import ICSErrorCard from '../../../components/ICSErrorCard/ICSErrorCard'
import './resultsGrid.css'
import './DataViewCell.css'

const ResultsBox: React.FC = () => {
  const loading = useAppSelector((state) => state.data.loading)
  const error = useAppSelector((state) => state.data.error)

  if (loading) {
    return <LoadIndicator />
  } else if (error) {
    return (
      <ICSErrorCard
        title="An error occured"
        message={error.message}
        code={error.code}
        fields={error.fields}
      />
    )
  }

  return (
    <Container fluid={true}>
      <div className="results-selection-container">
        <ResultsActionSelector />
        <TypeSelectAll />
      </div>
      <Row>
        <ResultsGrid />
      </Row>
    </Container>
  )
}

export default ResultsBox
